import SvgIcon from "@mui/material/SvgIcon";

export default function CreateActionIcon({ sx, ...props }) {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{ fontSize: 16, ...sx }}
      {...props}
    >
      <path
        d="M5.75 18.25h8.8c1.1 0 2-.9 2-2v-4.8"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
      <path
        d="M5.75 18.25V8.65c0-1.1.9-2 2-2h4.8"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
      <path
        d="M9.35 14.65l.7-3.2 6.15-6.15a1.45 1.45 0 0 1 2.05 0l.45.45a1.45 1.45 0 0 1 0 2.05l-6.15 6.15-3.2.7Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
    </SvgIcon>
  );
}
